<div class="header">
  <div>
    <h2>Setup Text Automation</h2>
    <p>
      Easily configure and manage automated text messages to streamline
      communication and ensure timely notifications.
    </p>
  </div>
  <button class="add-btn" (click)="toggleModal()">
    <img src="assets/images/PlusIcon.svg" alt="" />Add Automation Text
  </button>
</div>

<div class="rp-body">
  <div class="table-wrapper">
    <table>
      <thead>
        <tr>
          <th>Title</th>
          <th>Automation Text</th>
          <th class="text-right pr-4">Action</th>
        </tr>
      <tbody *ngIf="loading || showSkeleton">
        <tr *ngFor="let row of skeletonRows">
          <td *ngFor="let col of skeletonCols">
            <div class="skeleton-cell"></div>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="!loading && !showSkeleton">
        @for (item of setupText; track item.id; let i = $index) {
        <tr>
          <td>{{ item.title }}</td>
          <td>{{ item.text }}</td>
          <td class="text-right">
            <div class="icon-btns">
              <button class="btn-icon" (click)="openEditModal(item, $index)">
                <img src="assets/images/editIcon.svg" alt="Edit" />
              </button>
              <button class="btn-icon" (click)="openDeleteModal(item.id)">
                <img src="assets/images/trashIcon.svg" alt="Delete" />
              </button>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<app-add-popup *ngIf="showModal" [title]="isEditMode ? 'Edit Automation Text' : 'Add Automation Text'" [subtitle]="
    isEditMode
      ? 'Update text details to modify this record'
      : 'Create a reusable text that can be automatically applied when needed.'
  " [iconPath]="
    isEditMode ? 'assets/images/editPopup.png' : 'assets/images/addPopup.png'
  " (close)="toggleModal()">
  <form [formGroup]="automationForm" (ngSubmit)="onSave()">
    <div class="input-group">
      <label>Automation Text*</label>
      <input type="text" formControlName="text" placeholder="Write here" />
    </div>

    <div class="input-group">
      <label>Type*</label>
      <div class="select-wrapper">
        <select formControlName="typeId">
          <option [ngValue]="null" disabled selected>Choose from here</option>
          @for (t of types; track t.id) {
          <option [ngValue]="t.id">{{ t.title }}</option>
          }
        </select>
        <span class="arrow">
          <img src="assets/images/chevron-down.svg" alt="v" />
        </span>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="toggleModal()">

        Cancel
      </button>
      <button type="submit" class="btn-save" [disabled]="automationForm.invalid">
        <img src="assets/images/savePopup.svg" alt="" />
        Save
      </button>
    </div>
  </form>
</app-add-popup>
<!-- Delete Confirmation Modal -->
<app-add-popup *ngIf="showDeleteModal" title="Delete Automation Text"
  subtitle="Are you sure you want to delete this automation text? This action cannot be undone."
  iconPath="assets/images/deleteicon.svg" (close)="closeDeleteModal()">
  <div class="modal-footer justify-center">
    <button type="button" class="btn-cancel" (click)="closeDeleteModal()">
      Cancel
    </button>
    <button type="button" class="btn-save" (click)="confirmDelete()">
      <span> <fa-icon [icon]="faTrashCan"></fa-icon></span>Delete
    </button>
  </div>
</app-add-popup>